'use client';

import { Memorial } from '@/lib/types';

interface MemorialBioProps {
  memorial: Memorial;
}

export function MemorialBio({ memorial }: MemorialBioProps) {
  if (!memorial.descriptions) return null;

  const paragraphs = memorial.descriptions.split('\n\n').filter(Boolean);

  return (
    <section className="py-12 bg-white">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="font-serif text-2xl md:text-3xl text-memorial-primary text-center mb-8">
          Nachruf
        </h2>

        <div className="relative">
          {/* Decorative quote marks */}
          <div className="absolute -top-4 -left-2 text-6xl text-memorial-muted font-serif leading-none">
            &ldquo;
          </div>

          <div className="prose prose-lg max-w-none text-memorial-text-primary/90 leading-relaxed pl-6">
            {paragraphs.map((paragraph, index) => (
              <p key={index} className="mb-4 last:mb-0">
                {paragraph}
              </p>
            ))}
          </div>

          <div className="absolute -bottom-4 -right-2 text-6xl text-memorial-muted font-serif leading-none rotate-180">
            &ldquo;
          </div>
        </div>

        {/* Decorative divider */}
        <div className="mt-10 flex items-center justify-center gap-3">
          <div className="w-16 h-px bg-memorial-muted" />
          <div className="w-1.5 h-1.5 rounded-full bg-memorial-secondary" />
          <div className="w-16 h-px bg-memorial-muted" />
        </div>
      </div>
    </section>
  );
}
